import MediaRender from './MediaRender';

export default MediaRender;
